import { Hotel } from '@fr/vue/types';

export default function (hotels: any[]): Partial<Hotel>[] {
    return hotels?.map((h) => ({
        id: h.get('id'),
        name: h.get('name'),
        country: h.get('country'),
    })) || [];
}